import { SimplePageContentWrapper, SimplePageLayout, SimplePageHeader } from '@flexinet/ui-components';
import { Text } from '@mantine/core';
import { ReportPageNavigation } from '../navigation/ReportPageNavigation';

export const PaymentsReportPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<SimplePageHeader title="Payments Report" />}
      pageNavigation={<ReportPageNavigation reportName="Payments Report" />}
    >
      <SimplePageContentWrapper>
        <Text>Payments report table will be implemented when payments module is available.</Text>
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};